const SESSION_TOKEN_KEY = "sessionToken";

export const getSessionToken = () => {
  try {
    return localStorage.getItem(SESSION_TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const setSessionToken = (token) => {
  if (!token) return;
  try {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  } catch (_) {
    /* ignore storage failures */
  }
};

export const clearSessionToken = () => {
  try {
    localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch (_) {
    /* ignore storage failures */
  }
};
